import BookingSuccess from '../../../Pasajebus/PasajebusPaymentDetails/BookingSuccess/BookingSuccess';
import React from 'react';

function RenderBookingConfirmation({ status, pnrNumber, history, t }) {
  if (status == 'success') {
    return (
      <BookingSuccess
        pnrNumber={pnrNumber}
        // loading={this.props.common.loadTicketDetailsPending}
        // ticketDetails={this.props.common.ticketDetails}
        history={history}
        success={true}
        t={t}
        appType={localStorage.getItem('appType')}
      />
    );
  } else if (status == 'failure') {
    return <BookingSuccess success={false} />;
  }
}

export default RenderBookingConfirmation;



// WEBPACK FOOTER //
// ./src/features/home/ThankYouPage/RenderBookingConfirmation/RenderBookingConfirmation.js